<style>
.ql-bubble .ql-tooltip {
  background-color: #444;
  position: fixed;
  border-radius: 25px;
  color: #fff;
  display: fix;
  z-index: 99999999 !important;
}
.ql-editor {
  overflow-y: auto;
  max-height: 900px;
}
.editor-element {
  min-height: 700px;
}
.inform .editor-element {
  min-height: 300px;
}
.ql-container.ql-snow {
    border: 0px solid #ccc;
}
.inform .ql-toolbar.ql-snow {
    position: absolute;
    background-color: #fff;
    z-index: 999;
    width: 100%;
}
.inform .ql-toolbar.ql-snow + .ql-container.ql-snow {
    padding-top: 70px;
}
.ql-mention-list {
    height: 200px;
    overflow-y: auto;
}
.ql-mention-list-item {
    font-size: 12px;
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
}
.ql-container table {
  border-collapse: collapse;
} 
.ql-container .border td {
  border: 1px solid #ccc; 
  padding: 10px; 
}
.ql-divider:after {
  content: "-";
}
.ql-editor hr {
    border: none;
    color: #111;
    letter-spacing: 1em;
    text-align: center;
}

.ql-editor {
  counter-reset: number;
}
.ql-editor hr {
  counter-increment: number;
}
.ql-editor hr:before {
  content: '..... PAGE BREAK ' counter(number) ' .....';
}

.ql-snow .ql-picker.ql-tableHandler .ql-picker-item[data-label]:not([data-label=''])::before {
  content: attr(data-label);
}
.ql-snow .ql-picker.ql-tableHandler {
    width: 150px;
}

table.noborder td {
  border: 0px dashed #ccc !important;
}
.quill-edit-mode table.noborder td {
  border: 1px dashed #ccc !important;
}

@media print {
  hr {
      page-break-after: always; 
      display: none;
  }
}
button.ql-table[value="add-border"]::after {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAA/UlEQVRoge2ZXQ6CMBCER0+hNxIV9f4PYij4ewf0AQiaSGkXykqcL2nCQzvTAbKFFiCEkF/lAOAB4NnREgCRQH9dje3SvwGIJQHODuJ1MwL9zEM/bxOZWwwWgkn58PTou5QauLQjgJVAP6rGuvp8ZdYRwLVvCJz8ba/QJGAAbRhAG1uA09t1EnoiIfwjlCusgazO90Xbn5C/Z4Pyk9lA9r+gjkHzJZmGMpn8QhaSuo6nYB0nRIU9gDvKfZndFP1zNHU8G25ew/pzV0IbBtCGAbTxCTD2+UBvCov42OcDRZuI7QlcBZPywecuXyQGMT5XQ63zgQzAVhKAEELC8wI086IpOGTmpwAAAABJRU5ErkJggg==);
}

.ql-borderblock:after {
  content: "[]";
}

.borderblock {

    background-color: #F8F8F8;
    border: 1px solid #CCC;
    line-height: 19px;
    padding: 6px 10px;
    border-radius: 3px;
    margin: 15px 0;
}


</style>
<template>
<div style="height: 100%; overflow-y: auto; border: 1px solid #ccc" :class="className ? className : 'inform'">
  <div class="quill-editor editor-example bubble editor-element" align-center="" v-if="mode && mode == 'preview'">
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="previewContent"></div>
    </div>
  </div>
  <quill-editor v-else
    align-center
    class="editor-example bubble editor-element quill-edit-mode" 
    v-model="element.model"
    ref="myQuillEditor"
    :options="editorOption"
    @change="onEditorChange($event)"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
  ></quill-editor>
</div>
</template>
<script>
import { Quill } from "vue-quill-editor";
//import { ImageDrop } from "quill-image-drop-module";
//import ImageResize from "quill-image-resize-module";
window.Quill = Quill;

import {getValues, insertValues, interpolate, compile, injectStyles} from '@/lib/html.js';

import Mention from "quill-mention";

Quill.register("modules/mention", Mention);

let BlockEmbed = Quill.import('blots/block/embed');

let Inline = Quill.import('blots/inline');

class BorderBlock extends Inline{    
    static create(value){
        let node = super.create();
        node.setAttribute('class','borderblock');
        return node;    
    } 
}

BorderBlock.blotName = 'borderblock';
BorderBlock.tagName = 'table';
Quill.register(BorderBlock);




class DividerBlot extends BlockEmbed { }
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';

Quill.register(DividerBlot);

import quillTable from 'quill-table';
// import blot from '@/lib/TableBlot';
// import Delta from 'quill-delta';

// console.log('blot', blot);
// e7l34h7v5yf

// let Parchment = Quill.import('parchment');
export const Parchment = Quill.import("parchment")



Quill.register(quillTable.TableCell);
Quill.register(quillTable.TableRow);
Quill.register(quillTable.Table);
Quill.register(quillTable.NoBorderTable);
Quill.register(quillTable.Contain);
Quill.register('modules/table', quillTable.TableModule);

const TableClass = new Parchment.Attributor.Class('table', 'table', {
    scope: Parchment.Scope.BLOCK_BLOT,
    whitelist: [ 'no-border', 'border', 'border-4']
});

// Quill.register(TableClass, true);
console.log('TableClass', TableClass);


//import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
//import "quill/dist/quill.bubble.css";
import "quill-mention/dist/quill.mention.min.css";

import { quillEditor } from "vue-quill-editor";

const maxRows = 10;
const maxCols = 5;
const tableOptions = [];
for (let r = 1; r <= maxRows; r++) {
    for (let c = 1; c <= maxCols; c++) {
        tableOptions.push('newtable_' + r + '_' + c);
    }
}



// const config1 = {
//   scope: Parchment.Scope.BLOCK,
// };


// Quill.register(TableClass, true);

// let config = { scope: Parchment.Scope.ANY };
// let SpanWrapper = new Parchment.Attributor.Class('span-wrapper', 'span', config);
// Quill.register(SpanWrapper, true)

export default {
  props: ["element", "chart", "module", "className", "mode"],
  data: function() {
    const that = this;
    return {
      content: "",
      previewContent: "",
      editorOption: {
        theme: "snow",
        modules: {
          table: true,
          mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: function(searchTerm, renderList, mentionChar) {

              let module = null;
              if(typeof that.module != "undefined" && typeof that.module.getMentions != "undefined") {
                module = that.module;
              }
              if(!module && typeof that.element != "undefined" && typeof that.element.getMentions != "undefined") {
                module = that.element;
              }
              if(!module) {
                return;
              }
              let values = module.getMentions();


              // if (mentionChar === "@") {
              //   values = atValues;
              // } else {
              //   values = hashValues;
              // }

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value
                      .toLowerCase()
                      .indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            }
          },
          toolbar: {
          container: [
            // [{tableHandler: ['2 Columns', 'Insert Row Above', 'Option 3', 'Option 4', 'Option 5']}],
            [
              {
                size: ["small", false, "large"]
              }
            ],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [
              {
                header: 1
              },
              {
                header: 2
              }
            ], // custom button values
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ],
            [
              {
                script: "sub"
              },
              {
                script: "super"
              }
            ], // superscript/subscript
            [
              {
                indent: "-1"
              },
              {
                indent: "+1"
              }
            ], // outdent/indent
            [
              {
                direction: "rtl"
              }
            ], // text direction

            [
              {
                color: []
              },
              {
                background: []
              }
            ], // dropdown with defaults from theme
            [
              {
                font: []
              }
            ],
            [
              {
                align: []
              }
            ],

            ["clean"],
            [
              {
                list: "ordered"
              },
              {
                list: "bullet"
              }
            ],
            ["image"],
            ["divider"],
            [{table: tableOptions}, {table: 'append-row'}, {table: 'append-col'}, {table: 'add-border'}],
          ],
           handlers: {
            divider: function() {
                const quill = this.quill;
                let range = quill.getSelection(true);
                quill.insertText(range.index, '\n', Quill.sources.USER);
                quill.insertEmbed(range.index + 1, 'divider', true, Quill.sources.USER);
                quill.setSelection(range.index + 2, Quill.sources.SILENT);
            },
            tableHandler: function(value) {
              if (value) {
                // alert(value);
                    // const cursorPosition = this.quill.getSelection().index;
                    // this.quill.insertText(cursorPosition, value);
                    // this.quill.setSelection(cursorPosition + value.length);
                }
            }
        }
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          }
        }
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    getClean(html) {

    },
    getMentions() {
      // if(this.mentions) {
      //   return
      // }
    },
    onEditorBlur(quill) {
      // alert("hey");
      //console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      //console.log("editor focus!", quill);
      // quill.theme.tooltip.edit();
      //quill.theme.tooltip.show();
      //return false;
    },
    onEditorReady(quill) {
      //console.log('editor ready!', quill)

      // const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-tableHandler .ql-picker-item'));

      //   placeholderPickerItems.forEach(item => item.textContent = item.dataset.value);

      //   document.querySelector('.ql-tableHandler .ql-picker-label').innerHTML
      //       = 'Table' + document.querySelector('.ql-tableHandler .ql-picker-label').innerHTML;

      // let spanBlockButton = document.querySelector('.ql-borderblock');

      // spanBlockButton.addEventListener('click', function() {
      //         console.log('function called');
      //         var range = quill.getSelection();
      //         if(range){
      //             console.log('range is valid');
      //             quill.formatText(range,'borderblock');
      //         }else{
      //             console.log('it it invalid');
      //         }

      //     }
      // );
    },
    onEditorChange({ quill, html, text }) {
      
      //console.log('editor change!', quill, html, text)
      //  this.content = html
      //this.chart.changed(this.chart.parameters.content);
      //console.log(this.chart.parameters.content.value);
      // console.log("element.model", this.element.model);

      // element.updateModel()
    }
  },
  computed: {},
  mounted: function() {
    const that = this;
    // console.log("this.module", this.module);
    //console.log("this.element", this.element);
    if(this.module && this.element && this.element.model) {
      // alert("here");
      // that.previewContent = interpolate(that.element.model, params);
      try {
        this.module.lib.editorElement = {};
        this.module.lib.editorElement.setPreviewContent = function(params) { 
          console.log("preview content", params);
          that.previewContent = interpolate(that.element.model, params);
        }
        this.module.lib.editorElement.getPreviewContent = function(params) { 
          let content = interpolate(that.element.model, params);
          return content;
        }
        this.module.lib.editorElement.getPreviewContentIncludingStyle = function(params) { 
          let content = interpolate(that.element.model, params);
          return injectStyles(content);
        }
      } catch(error) {

      }
    }
    // alert("mounted");
    //  console.log('this is current quill instance object', this.myQuillEditor);
  },
  beforeDestroy() {}
};
</script>
